var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57129 10.0308C8.57129 11.9197 10.1025 13.4508 11.9913 13.4508C13.8789 13.4479 15.4083 11.9184 15.4113 10.0308C15.4113 8.14203 13.8801 6.61084 11.9913 6.61084C10.1025 6.61084 8.57129 8.14203 8.57129 10.0308ZM9.70951 10.0362C9.70951 8.77599 10.7311 7.7544 11.9913 7.7544C13.2515 7.7544 14.2731 8.77599 14.2731 10.0362C14.2731 11.2964 13.2515 12.318 11.9913 12.318C10.7311 12.318 9.70951 11.2964 9.70951 10.0362Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5082,
    y: 3.46279,
    width: 16.8,
    height: 16.8,
    rx: 2.1,
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9883 16.9406C15.8457 16.9409 15.7084 16.8875 15.6035 16.791C14.8692 16.1066 13.9034 15.7249 12.8996 15.7223H11.088C10.0842 15.7249 9.11844 16.1066 8.3841 16.791C8.23516 16.9398 8.0165 16.9947 7.81493 16.9339C7.61337 16.8732 7.46151 16.7065 7.41964 16.5002C7.37777 16.2939 7.45267 16.0812 7.6146 15.9467C8.56139 15.0756 9.80147 14.5929 11.088 14.5947H12.8942C14.1841 14.5945 15.4265 15.0811 16.373 15.9574C16.5431 16.1171 16.5991 16.3642 16.5145 16.5816C16.4299 16.7991 16.2216 16.9433 15.9883 16.946V16.9406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.55957e58030af2948f867677f1a15097.svg";
export { ForwardRef as ReactComponent };